export default "__VITE_ASSET__BaZor1kE__"